export default {
  name: 'FcIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '18px',
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  render() {
    const { className, color, size, $listeners } = this;
    return (
      <span
        {...{ on: $listeners }}
        class={`iconfont ${className}`}
        style={`${color ? `color:${color}` : ''};font-size:${size}`}
      ></span>
    );
  },
};
